import { URL_MODEL } from '../helpers/endpoint';
import { baseBackend } from './base/baseUrl';

export const getModels = async () => {
  return await baseBackend.get(URL_MODEL, {
    headers: { "Content-Type": "application/json" },
  });
};